export default __webpack_public_path__ + "5b80db0db8c013fa8a11cce32890ead7.svg";